import React, { useState, useEffect,useRef } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftCircle } from "react-bootstrap-icons";
import ELayout from './ELayout';
import AxiosInstance from '../AxiosInstance';
import Accordion from 'react-bootstrap/Accordion';
import ToastNotification from "../ToastNotification";
const LeaveRequest = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [leaveType, setLeaveType] = useState(''); // Store the name for display
  const [leaveTypeId, setLeaveTypeId] = useState(''); // Store the ID for submission
  const [reason, setReason] = useState('');
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaveBalance, setLeaveBalance] = useState([]);
  const [remainingBalance, setRemainingBalance] = useState(null);
  const toastRef=useRef();
  const navigate = useNavigate();
  const employeeId = Number(localStorage.getItem('employeeId'));
  // Fetch leave types
  useEffect(() => {
    if (employeeId) {
      AxiosInstance.get(`/employee/leaveTypes`)
        .then((response) => {
          console.log('Leave Types:', response.data); // Log the leave types response
          setLeaveTypes(response.data);
        })
        .catch((error) =>  toastRef.current?.showToast('Error fetching leave types:', "danger"));
    }
  }, [employeeId]);

  // Fetch leave balance
 useEffect(() => {
  if (employeeId) {
    console.log("Fetching leave balance for employeeId:", employeeId); // Check the ID

    AxiosInstance.get(`/employee/getLeaveBalance/${employeeId}`)
      .then((response) => {
        setLeaveBalance(response.data);
      })
      .catch((error) => {
        toastRef.current?.showToast('Error fetching leave balance', "danger");
      });
  }
}, [employeeId]);


  
  const handleLeaveTypeChange = (e) => {
    const selectedName = e.target.options[e.target.selectedIndex].text; // Get leave type name
    const selectedId = e.target.value; // Get leave type ID (now value is the ID)

    setLeaveType(selectedName); // Store the leave name for display
    setLeaveTypeId(selectedId); // Store the leave type ID for submission

    // Find matching leave type from the leaveBalance array
    const selectedLeave = leaveBalance.find(leave => leave.leave_name.trim() === selectedName.trim());

    if (selectedLeave) {
      // Update remaining balance based on the selected leave type
      setRemainingBalance(prevBalance => {
        const newBalance = selectedLeave.remaining_leave === "Unlimited" ? "Unlimited" : Number(selectedLeave.remaining_leave);
        return newBalance;
      });
    } else {
      setRemainingBalance(null); // Reset balance if no matching leave type is found
    }
  };


  const handleSubmit = () => {
    if (!startDate || !endDate || !leaveType || !reason) {
        toastRef.current.showToast('Please fill out all fields.', 'warning');
        return;
    }
    console.log("Validation Check:", { remainingBalance });
    // Validate if remaining leave balance is enough
    if (remainingBalance !== null && remainingBalance !== "Unlimited") {
      const maxLeave = Number(remainingBalance);  // Ensure it's a number
      const requestedDays = Math.ceil((new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24)) + 1;  
      
      if (requestedDays > maxLeave) {
          toastRef.current.showToast(`You only have ${maxLeave} days left for this leave type.`, "danger");
          return;
      }
  }  
    if (!employeeId) {
        toastRef.current.showToast("Error: Employee ID is missing. Please log in again.", 'danger');
        return;
    }

    const leaveData = {
      employee_id: employeeId,
      start_date: startDate,
      end_date: endDate,
      leave_type_id: leaveTypeId, // Use leaveTypeId here instead of leaveType
      reason,
    };
    AxiosInstance.post('/employee/submitleaverequest', leaveData)
        .then((response) => {
            toastRef.current.showToast(response.data.message || 'Leave request submitted successfully.', 'success');
        })
        .catch(() => toastRef.current.showToast('Error submitting leave request.', 'danger'));
  };

  return (
    <ELayout heading={
      <div className="mb-3 d-flex align-items-center">
      <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
        <ArrowLeftCircle />
      </Button>
      <span className="ms-3">Leave Request</span>
      </div>
    }>
    <Accordion className="my-3">
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <strong style={{ color: "grey" }}>Check Leave Balance</strong>
        </Accordion.Header>
        <Accordion.Body>
          {leaveBalance.length > 0 ? (
            <div className="d-flex justify-content-center">
              <div className="table-responsive">
                <table className="table table-hover align-middle table-striped">
                  <thead className="table-primary">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col" className="text-start">Leave Type</th>
                      <th scope="col">Used</th>
                      <th scope="col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {leaveBalance.map((leave, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="text-start">{leave.leave_name}</td>
                        <td>{leave.used_leave}</td>
                        <td>{leave.total_balance === -1 ? "N/A" : leave.total_balance}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <p className="text-muted">No leave data available.</p>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>

      <Form>
        <Form.Group>
          <Form.Label>Start Date</Form.Label>
          <Form.Control type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </Form.Group>
        <Form.Group>
          <Form.Label>End Date</Form.Label>
          <Form.Control type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Type of Leave</Form.Label>
          <Form.Control
            as="select"
            value={leaveTypeId} // This should hold the ID for submission
            onChange={handleLeaveTypeChange}
          >
            <option value="">Select</option>
            {leaveTypes.map((type) => (
              <option key={type.id} value={type.id}> {/* Set value to leave type ID */}
                {type.leave_name}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <p style={{ fontSize: "0.9rem", color: "grey" }}>
          {remainingBalance !== null ? `Remaining Balance: ${remainingBalance} days` : ""}
        </p>
        <Form.Group>
          <Form.Label>Reason</Form.Label>
          <Form.Control as="textarea" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} />
        </Form.Group>
        <div style={{ marginTop: "16px", display: "flex", gap: "10px" }}>
          <Button className="btn btn-secondary" onClick={handleSubmit}>Submit</Button>
        </div>
      </Form>
      <ToastNotification ref={toastRef} />
    </ELayout>
  );
};

export default LeaveRequest;